import { useState } from "react";
import { createPortal } from "react-dom";
import { FileText, X, Check, ArrowRight } from "lucide-react";

// Scelta del modello CAI/CID prima di aprire il form editabile. onSelect(modello).
export default function CaiCidOptionsDialog({ onClose, onSelect }) {
  const [modello, setModello] = useState("ufficiale");
  const [intestazione, setIntestazione] = useState(true);

  const Option = ({ value, titolo, descr }) => {
    const active = modello === value;
    return (
      <button type="button" data-testid={`cai-modello-${value}`} onClick={() => setModello(value)}
        className={`w-full text-left rounded-md border p-3 transition-colors ${active ? "border-blue-500 bg-blue-500/10" : "border-slate-700 hover:bg-slate-800/60"}`}>
        <div className="flex items-center gap-2">
          <span className={`h-4 w-4 rounded-full border flex items-center justify-center ${active ? "border-blue-400 bg-blue-500" : "border-slate-500"}`}>
            {active && <Check className="h-3 w-3 text-white" />}
          </span>
          <span className="font-semibold text-slate-100 text-sm">{titolo}</span>
        </div>
        <p className="text-xs text-slate-400 mt-1 ml-6">{descr}</p>
      </button>
    );
  };

  return createPortal(
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 p-4" data-testid="cai-options-dialog">
      <div className="bg-[#121824] border border-slate-700 rounded-lg shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-700">
          <div className="font-head font-semibold text-slate-100 flex items-center gap-2"><FileText className="h-4 w-4 text-blue-400" /> Scegli il modello CAI/CID</div>
          <button type="button" onClick={onClose} data-testid="cai-options-close" className="text-slate-400 hover:text-slate-100"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-4 space-y-3">
          <Option value="ufficiale" titolo="Ufficiale (modulo CAI)" descr="Fedele al modulo ufficiale italiano: 3 colonne (Veicolo A / circostanze / Veicolo B), circostanze 1-17, croquis, Altre informazioni. 2 pagine." />
          <Option value="compatto" titolo="Compatto (studio)" descr="Riepilogo su misura, A4 su una pagina: dati sinistro, tabella Veicolo A/B, dinamica, croquis e firme." />
          <label className="flex items-center gap-2 mt-1 cursor-pointer select-none" data-testid="cai-intestazione-toggle">
            <input type="checkbox" checked={intestazione} onChange={(e) => setIntestazione(e.target.checked)} className="h-4 w-4 accent-blue-500" />
            <span className="text-sm text-slate-200">Includi l'intestazione dello studio</span>
          </label>
        </div>
        <div className="flex justify-end gap-2 px-4 py-3 border-t border-slate-700">
          <button type="button" onClick={onClose} className="text-sm rounded-md border border-slate-600 text-slate-200 hover:bg-slate-800 px-3 py-1.5">Annulla</button>
          <button type="button" data-testid="cai-modello-continua" onClick={() => onSelect(modello, intestazione)}
            className="flex items-center gap-2 text-sm rounded-md bg-blue-500 hover:bg-blue-600 text-white font-semibold px-3 py-1.5">
            Continua <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
